﻿import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

import { Customer } from '../_models/user';
import { MoghimAuthenticationProxy } from '@core/Proxies/MoghimAuthenticationProxy';


@Injectable({ providedIn: 'root' })
export class AuthService {
    private currentUserSubject: BehaviorSubject<Customer>;
    public currentUser: Observable<Customer>;
    constructor(private http: HttpClient) {
        var storageToken = sessionStorage.getItem("_a_token");
        this.currentUserSubject = new BehaviorSubject<Customer>({ token : storageToken });
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): Customer {
        if(this.currentUserSubject && this.currentUserSubject.value.token && this.currentUserSubject.value.token.length) return this.currentUserSubject.value;
        return null;
    }

    setUser(model) {
        sessionStorage.setItem('_a_user', JSON.stringify(model));
        this.currentUserSubject.next(model);
    }

    setCustomerStorage(token : string)
    {
        sessionStorage.setItem("_a_token",token);
        this.currentUserSubject.next({ token : token });
    }

    login(username: string, password: string) {
        let proxy = new MoghimAuthenticationProxy(this.http);
        let _login = proxy.Login({ username : username , password : password });
        _login.subscribe(
            user => {
                if (user) {
                    this.setCustomerStorage(user.model.token);
                } else this.currentUserSubject.next(null);
                return user;
            },
            reject => {
                console.log('authError',reject);
            }
        );
        return _login;
    }

    logout() {
        sessionStorage.removeItem('_a_user');
        this.currentUserSubject.next(null);
        // this.currentUser = this.currentUserSubject.asObservable();
        // this.router.navigate(['/']);
    }


    
    
}